
import React from 'react';

export const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Company Opening & Regularization',
      description: 'Incorporation, registration, Tax ID (CNPJ), and licenses',
      features: ['Feasibility analysis', 'Commercial Registry registration', 'License acquisition', 'Tax registrations']
    },
    {
      icon: 'ri-bar-chart-line',
      title: 'Management Accounting',
      description: 'Trial balances, Income Statements (DRE), balance sheets, and management reports',
      features: ['Financial statements', 'Indicator analysis', 'Customized reports', 'Asset control']
    },
    {
      icon: 'ri-calculator-line',
      title: 'Tax Planning',
      description: 'Defining the ideal regime and reducing tax burden',
      features: ['Tax regime analysis', 'Tax avoidance', 'Tax simulations', 'Tax optimization']
    },
    {
      icon: 'ri-team-line',
      title: 'Personnel Department',
      description: 'Payroll, eSocial, admissions, and dismissals',
      features: ['Payroll', 'Admissions and dismissals', 'eSocial and FGTS', 'Benefits and vacations']
    },
    {
      icon: 'ri-file-text-line',
      title: 'Ancillary Obligations',
      description: 'SPED, DCTF, DEFIS, ECD, ECF, and tax declarations',
      features: ['Fiscal and Accounting SPED', 'Federal declarations', 'State obligations', 'Deadlines and alerts']
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Tax Advisory',
      description: 'Tax calculation and tax slip issuance',
      features: ['Tax calculation', 'Tax slip issuance', 'Installments', 'Defenses and appeals']
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Business Consulting',
      description: 'Feasibility, restructuring, and financial management',
      features: ['Feasibility analysis', 'Corporate restructuring', 'Financial management', 'Strategic planning']
    },
    {
      icon: 'ri-computer-line',
      title: 'Digital Accounting',
      description: 'Online access to key business indicators',
      features: ['Client portal', 'Online reports', 'Real-time indicators', 'Cloud backup']
    }
  ];

  return (
    <section id="servicos" className="py-20 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-[#1A3A52] mb-6 font-['Playfair_Display']">
            Our Services
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We offer complete solutions in accounting, taxation, and business management
            to boost your business growth
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-[#00A896] rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>

              <h4 className="text-lg font-semibold text-[#1A3A52] mb-3 text-center">
                {service.title}
              </h4>

              <p className="text-gray-600 text-sm mb-4 text-center">
                {service.description}
              </p>

              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-[#00A896] mr-2 text-xs"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg text-gray-600 mb-6">
            Need a specific service? Contact us!
          </p>
          <button
            onClick={() => window.open('https://wa.me/5541996543210', '_blank')}
            className="bg-[#25D366] hover:bg-[#20B858] text-white px-8 py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            Request a Quote
          </button>
        </div>
      </div>
    </section>
  );
};
